import Vue from 'vue'
import Constants from '../../constants'
import i18n from '../../i18n'
import _ from 'lodash'
import api from '../../api/docomo'
import middle from '../../api/middle_layer'

const getDefaultState = () => {
  return {
    token: null,
    lang: null,
    filter: {},
    bearers: {},
    appId: null
  }
}

const state = getDefaultState()

const getters = {
  getToken: (state) => state.token || Vue.$cookies.get(Constants.TOKEN_KEY),
  getLang: (state) => state.lang,
  getAppId: (state) => state.appId,
  isFilterOn: (state) => (genre) => {
    return !!state.filter[genre.id]
  },
  getFilter: (state) => state.filter,
  getBearerToken: (state) => (serviceAreaId) => {
    const bearer = state.bearers[serviceAreaId]
    return bearer && bearer.token
  },
  getUuid: (state) => state.uuid,
  isMaebashi: (state) => state.maebashi,
  hasTicket: (state) => !_.isEmpty(state.ticket),
  getTicket: (state) => state.ticket
}

const actions = {
  setToken ({ commit, dispatch }, params) {
    dispatch('resetAll', {}, { root: true })
    Vue.$cookies.set(Constants.TOKEN_KEY, params)

    commit('setToken', { token: params })
  },
  resetToken ({ commit }) {
    commit('resetToken')
  },
  setLang ({ commit }, params) {
    if (Constants.AVAILABLE_LANGUAGES.includes(params)) {
      i18n.locale = params
    } else {
      i18n.locale = 'ja'
    }
    commit('setLang', { lang: i18n.locale })
  },
  onFilterFromTag ({ commit }, tagId) {
    const genre = {
      id: tagId
    }
    commit('setOnFilter', genre)
  },
  offFilterFromTag ({ commit }, tagId) {
    const genre = {
      id: tagId
    }
    commit('setOffFilter', genre)
  },
  onFilter ({ commit }, genre) {
    commit('setOnFilter', genre)
  },
  offFilter ({ commit }, genre) {
    commit('setOffFilter', genre)
  },
  onFilterAll ({ commit }) {
    commit('setOnFilterAll')
  },
  offFilterAll ({ commit }) {
    commit('setOffFilterAll')
  },
  updateFilter ({ commit, state }, genres) {
    var filter = {};
    if (state.filter !== undefined && !_.isEmpty(state.filter)) {
      filter = Object.assign({}, state.filter);
    }
    genres.forEach((genre) => {
      if (filter[genre.id] === undefined) {
        filter[genre.id] = genre.filterDefault
        if (genre.children) {
          genre.children.forEach((child) => {
            if (filter[child.id] === undefined) {
              filter[child.id] = child.filterDefault
            }
          })
        }
      }
    })
    commit('setFilter', filter)
  },
  setFilter ({ commit }, genres) {
    var filter = {};
    genres.forEach((genre) => {
      filter[genre.id] = genre.filterDefault
      if (genre.children) {
        genre.children.forEach((child) => {
          filter[child.id] = child.filterDefault
        })
      }
    })
    commit('setFilter', filter)
  },
  reset ({ commit }) {
    commit('resetState')
  },
  create ({ commit }, { serviceAreaId, token }) {
    return new Promise((resolve) => {
      middle.information(token)
        .then((user) => {
          commit('setUuid', user.uuid)
          commit('setMaebashi', user.maebashi)
          commit('setTicket', user.ticket)
          api.createUser(serviceAreaId, user.uuid)
            .then((bearer) => {
              commit('setBearer', {
                serviceAreaId: serviceAreaId, token: bearer
              })
              resolve()
            })
        })
    })
  }
}

const mutations = {
  setToken (state, { token }) {
    state.token = token
    state.appId = Constants.API_ID
  },
  resetToken (state) {
    state.token = null
    Vue.$cookies.remove(Constants.TOKEN_KEY)
  },
  setLang (state, { lang }) {
    state.lang = lang
  },
  setFilter (state, genres) {
    state.filter = genres
  },
  setOnFilter (state, genre) {
    state.filter[genre.id] = true
    if (genre.relatedFilters !== undefined) {
      for (var i = 0; i < genre.relatedFilters.length; i++) {
        state.filter[genre.relatedFilters[i]] = true
      }
    }
  },
  setOffFilter (state, genre) {
    state.filter[genre.id] = false
    if (genre.relatedFilters !== undefined) {
      for (var i = 0; i < genre.relatedFilters.length; i++) {
        state.filter[genre.relatedFilters[i]] = false
      }
    }
  },
  setOnFilterAll (state) {
    for (let key in state.filter) {
      state.filter[key] = true
    }
  },
  setOffFilterAll (state) {
    for (let key in state.filter) {
      state.filter[key] = false
    }
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
    Vue.$cookies.remove(Constants.TOKEN_KEY)
  },
  setBearer (state, { serviceAreaId, token }) {
    state.bearers = Object.assign(state.bearers, { [serviceAreaId]: { token } })
  },
  setUuid (state, uuid) {
    state.uuid = uuid
  },
  setMaebashi(state, maebashi) {
    state.maebashi = maebashi
  },
  setTicket(state, ticket) {
    state.ticket = ticket
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
